import React from 'react'
import { Dimmer, Loader, Segment } from 'semantic-ui-react'
import './loading.scss';

const Loading = () => (
  <Loader active inline='centered'>Loading...</Loader>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/ui/loading/Loading.jsx